import { useEffect } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

// ─── Utils ────────────────────────────────────────────────────────────────────
import DialogUtils from "../../utils/DialogUtils";

// ─── Services ─────────────────────────────────────────────────────────────────
import OnboardingCustomerService from "../../services/api/OnboardingCustomerService";

// ─── Assets ───────────────────────────────────────────────────────────────────
import logo from "../../assets/img/logo.jpg";
import "./less/_onboarding_account.less";

// ─── Services (module-level) ──────────────────────────────────────────────────
const onboardingCustomerService = new OnboardingCustomerService();

// ─── Types ────────────────────────────────────────────────────────────────────
interface SuccessOnBoardingAccountProps {
  // Define props if needed
}

// ─── Component ────────────────────────────────────────────────────────────────
const SuccessOnBoardingAccount = (_props: SuccessOnBoardingAccountProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.backgroundColor = "white";
    checkHasOnboarding();

    return () => {
      // Cleanup for React 19 / Vite HMR
      document.body.style.backgroundColor = "";
    };
  }, []);

  const checkHasOnboarding = async () => {
    const result = await onboardingCustomerService.checkHasOnboarding();

    if (result?.details?.hasOnboarding) {
      updateUserAndNavigate(result.details.onboarding_id);
    } else {
      const successResult = await onboardingCustomerService.checkSuccess();
      if (successResult?.details?.isSuccess) {
        DialogUtils.success(
          "Onboarding account has been successfully created.",
          () => navigate("/restaurant_detail")
        );
      } else {
        DialogUtils.confirm(
          "Your onboarding is not yet completed. Please complete the information needed.",
          () => create(),
          () => navigate("/onboarding"),
          "Continue"
        );
      }
    }
  };

  const updateUserAndNavigate = (onboardingId: string) => {
    const userString = localStorage.getItem("user") || "{}";
    const userObj = JSON.parse(userString);
    userObj.onboardingAccounts = onboardingId;
    localStorage.setItem("user", JSON.stringify(userObj));
    navigate("/restaurant_detail");
  };

  const create = async () => {
    const result = await onboardingCustomerService.createLink();
    if (result?.details?.url) {
      window.location.href = result.details.url;
    } else {
      DialogUtils.error(
        "Something went wrong while creating the onboarding link. Please try again."
      );
    }
  };

  const existingAccount = async () => {
    const result = await onboardingCustomerService.createLinkExistingAccount();
    if (result) {
      window.location.href = result;
    } else {
      DialogUtils.error(
        "Something went wrong while creating the onboarding link. Please try again."
      );
    }
  };


  return (
    <div className="onboarding_main_div">
      <div className="onboarding_card" style={{ textAlign: "left" }}>
        <img src={logo} alt="appetit" className="onboarding_image" />
        <div className="onboarding_card_title">Merchant Onboarding</div>
        <div className="onboarding_card_body">
          You have no connected stripe account. Please create your account to
          allow your customers to order.
        </div>
        <Button
          className="main-primary-btn btn-width-100p"
          onClick={existingAccount}
        >
          EXISTING STRIPE ACCOUNT
        </Button>
        <Button
          style={{ marginTop: 15 }}
          className="main-primary-btn btn-width-100p"
          onClick={create}
        >
          NEW STRIPE ACCOUNT
        </Button>
      </div>
    </div>
  );
};

export default SuccessOnBoardingAccount;
